export default "__VITE_ASSET__AbW_tlCI__"